export default __webpack_public_path__ + "static/media/SeqLSTM-Models.2d1a3ea9.png";